import { ShipperResource } from 'app/_resources/shipper.resource';
import { AuthService } from 'app/_services/auth.service';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import { ShipperPremiumServiceSubscriptionResource } from 'app/_resources/shipper-premium-service-subscription.resource';
import * as angular from 'angular';
import { mgoAngularWizard } from '../custom';

class ShipperPremiumServicesWizardConfirmComponentCtrl
    implements ng.IController
{
    wizardCtrl: mgoAngularWizard.Wizard<ShipperPremiumServiceSubscriptionCreationDto>;
    whatYoGonnaBuy: ShipperPremiumServiceSubscriptionPackageDto;
    closeConfirmationPageOnBack: boolean;
    debtor: ShipperPremiumServiceBillingAddressCreationDto;

    constructor(
        private Shipper: ShipperResource,
        private authService: AuthService,
        private errorHandler: ErrorHandler,
        private shipperPremiumServiceSubscriptionResource: ShipperPremiumServiceSubscriptionResource
    ) {}

    get shipper(): Shipper {
        return this.wizardCtrl.currentStep().wzData.shipper;
    }

    get authUser(): LoginResult {
        return this.wizardCtrl.currentStep().wzData.authUser;
    }

    get confirmSepaMandate(): boolean {
        return this.wizardCtrl.currentStep().wzData.confirmSepaMandate;
    }

    set confirmSepaMandate(value: boolean) {
        this.wizardCtrl.currentStep().wzData.confirmSepaMandate = value;
    }

    $onInit(): void {
        this.debtor = angular.copy(this.wizardCtrl.context.debtor);

        this.shipperPremiumServiceSubscriptionResource.getPackages(
            (res: ShipperPremiumServiceSubscriptionPackageDto[]) => {
                this.whatYoGonnaBuy = res.find(
                    (value) =>
                        value.identifier ===
                        this.wizardCtrl.context.servicePackage
                );
            }
        );

        if (this.wizardCtrl.currentStep().wzData != null) {
            return;
        }

        this.wizardCtrl.currentStep().wzData = {};

        this.authService.userLoginPromise.promise.then((res) => {
            this.wizardCtrl.currentStep().wzData.authUser = res;

            this.Shipper.get(
                { id: this.authUser.referenceId },
                (res: Shipper) => {
                    this.wizardCtrl.currentStep().wzData.shipper = res;
                }
            );
        });
    }

    submit(isValid: boolean) {
        if (!isValid) return false;

        this.Shipper.shipperPremiumServicesSubscription(
            { id: this.authUser.referenceId },
            this.wizardCtrl.context,
            () => {
                this.wizardCtrl.finish();
            },
            this.errorHandler
        );

        return true;
    }

    saveDebtorDetails() {
        console.log(this.debtor);
        this.wizardCtrl.context.debtor = angular.copy(this.debtor);
    }
}

angular.module('app').component('pkpShipperPremiumServicesWizardConfirm', {
    controller: ShipperPremiumServicesWizardConfirmComponentCtrl,
    template:
        require('app/shipper-premium-services-wizard/shipper-premium-services-wizard-confirm.component.html'),
    bindings: {
        back: '&',
        closeConfirmationPageOnBack: '<'
    },
    require: {
        wizardCtrl: '^^wizard'
    }
});
